// extracted by mini-css-extract-plugin
module.exports = {"actions":"_2CnsPh","buttons":"_35iimI","cancelButton":"_3PfSuJ"};